import { StorageService } from '@/service/StorageService';

export function UserStorageServiceFactory() {
  return new StorageService({ key: 'api', encoded: false });
}
